import React from "react";
import { Title as TitleMantine } from "@mantine/core";

export interface TitleProps {
  title: React.ReactNode;
  size: 1 | 2 | 3 | 4 | 5 | 6;
  variant?: "primary" | "secondary";
  mb?: string;
}

export const Title = ({ ...props }: TitleProps) => {
  return (
    <TitleMantine
      order={props.size}
      style={{
        color: props.variant === "primary" ? "rgb(49, 88, 226)" : "#000000",
      }}
      mb={props.mb}
    >
      {props.title}
    </TitleMantine>
  );
};
